/**
 * Video Store
 * Controls video visibility across the app
 * 
 * @author Varun Pandey
 */

import { create } from 'zustand';

interface VideoState {
  showVideo: boolean;
  setShowVideo: (show: boolean) => void;
}

export const useVideoStore = create<VideoState>((set) => ({
  showVideo: false,
  setShowVideo: (show) => set({ showVideo: show }),
}));
